export default "__VITE_ASSET__8b3ba2ad__"